<template>
  <el-dropdown size="small" class="d2-mr">
    <span class="btn-text">你好 {{info.name}}</span>
    <el-dropdown-menu slot="dropdown">

      <el-dropdown-item @click.native="openViewForm">
        <d2-icon name="power-off" class="el-icon-refresh" /> 修改密码
      </el-dropdown-item>

      <el-dropdown-item @click.native="openSfzForm"  v-if="is_dl_type=='2'" >
        <d2-icon name="power-off" class="el-icon-user" /> 完善身份信息
      </el-dropdown-item>
      <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off" class="d2-mr-5" /> 退出
      </el-dropdown-item>
      <!-- <el-dropdown-item @click.native="resetDb">
        <i class="el-icon-refresh"></i> 初始化
      </el-dropdown-item> -->
    </el-dropdown-menu>
    <password-form
            v-model="viewFormVisible"
            @submit="getTableData"
    />
    <sfz-form
            v-model="sfzFormVisible"
            @submit="getTableData"
    />
  </el-dropdown>

</template>

<script>
import { mapState, mapActions } from "vuex";
import passwordForm from "./passwordForm";
import sfzForm from "./sfzForm";
import * as sysService from "@/api/sys/sys";
import util from '@/libs/util.js'
export default {
    components: { passwordForm,sfzForm},
  computed: {
    ...mapState("d2admin/user", ["info"])
  },
    data() {
        return {
            is_dl_type:util.cookies.get('dl_type'),
            viewFormVisible: false,
            sfzFormVisible: false
        }
    },
  methods: {
    ...mapActions("d2admin/account", ["logout"]),
    /**
     * @description 登出
     */
    logOff() {
      this.logout({
        vm: this,
        confirm: true
      });
    },
      openViewForm(){
          this.sfzFormVisible = false;
          this.viewFormVisible = true;
      },
      openSfzForm(){
          this.viewFormVisible=  false;
          this.sfzFormVisible = true;
      },
      getTableData(){

      },
    resetDb() {
      sysService.resetDb().then(() => {
        setTimeout(() => {
          location.reload();
        }, 1500);
      });
    }
  }
};
</script>
